// @flow
import * as React from 'react';
import {
  showClientMenu as show,
  hideClientMenu as hide,
} from './clientsActions';
import { connect } from 'react-redux';

type Props = {
  show: typeof show,
  hide: typeof hide,
  children: any,
};

class HideClientSelectMenu extends React.Component<
  Props,
  {
    isMounted: boolean,
  }
> {
  state = { isMounted: false };
  componentDidMount() {
    this.props.hide();
    this.setState({
      isMounted: true,
    });
  }

  componentWillUnmount() {
    this.props.show();
  }

  render() {
    return this.state.isMounted ? this.props.children : null;
  }
}

export default connect(null, { show, hide })(HideClientSelectMenu);



// WEBPACK FOOTER //
// ./src/containers/client/HideClientSelectMenu.js